import { supabase } from '../supabaseClient'
import { getHojeBR, toDataBR } from './dataBR'

/**
 * Retorna array de 7 strings YYYY-MM-DD para a semana atual (Dom→Sáb),
 * no fuso horário do Brasil.
 */
export function getWeekDays() {
  const todayStr = getHojeBR()
  const today = new Date(todayStr + 'T12:00:00')
  const sunday = new Date(today)
  sunday.setDate(today.getDate() - today.getDay())
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(sunday)
    d.setDate(sunday.getDate() + i)
    return toDataBR(d)
  })
}

/**
 * Busca a entrada de memória mais adequada do histórico do usuário.
 * Tenta (em ordem): 4 semanas atrás, 8 semanas, 2 semanas, 1 semana.
 * Só retorna entradas com nota escrita (mínimo 10 caracteres).
 * Retorna null se nenhuma encontrada.
 */
export function getMemoryEntry(logs) {
  const today = new Date(getHojeBR() + 'T12:00:00')
  for (const weeks of [4, 8, 2, 1]) {
    const target = new Date(today)
    target.setDate(today.getDate() - weeks * 7)
    const targetStr = toDataBR(target)
    const entry = logs.find(
      l => l.date === targetStr && l.note && l.note.trim().length >= 10
    )
    if (entry) return { ...entry, weeksAgo: weeks }
  }
  return null
}

/**
 * Busca os logs de um mês específico diretamente do Supabase.
 * @param {string} userId
 * @param {number} year  - ex: 2026
 * @param {number} month - 0-indexed (0=jan, 11=dez)
 */
export async function getLogsForMonth(userId, year, month) {
  const pad = n => String(n).padStart(2, '0')
  const from = `${year}-${pad(month + 1)}-01`
  const lastDay = new Date(year, month + 1, 0).getDate()
  const to = `${year}-${pad(month + 1)}-${pad(lastDay)}`

  const { data, error } = await supabase
    .from('daily_logs')
    .select('date, note, completed, mood_score')
    .eq('user_id', userId)
    .gte('date', from)
    .lte('date', to)
    .order('date', { ascending: true })

  if (error) { console.error('getLogsForMonth error:', error); return [] }
  return data || []
}

/**
 * Calcula stats de presença para um conjunto de logs.
 * @param {Array} logs
 * @param {number} year
 * @param {number} month - 0-indexed
 * @returns {{ daysPresent, withWriting, presencePercent }}
 */
export function calcMonthStats(logs, year, month) {
  const todayStr = getHojeBR()
  const today = new Date(todayStr + 'T12:00:00')
  const isCurrentMonth = today.getFullYear() === year && today.getMonth() === month
  const daysElapsed = isCurrentMonth
    ? today.getDate()
    : new Date(year, month + 1, 0).getDate()

  const completed = logs.filter(l => l.completed)
  const daysPresent = completed.length
  const withWriting = completed.filter(l => l.note && l.note.trim().length > 0).length
  const presencePercent = daysElapsed > 0
    ? Math.round((daysPresent / daysElapsed) * 100)
    : 0

  return { daysPresent, withWriting, presencePercent }
}
